import { useEffect, useState } from "react";
import { Any } from "@cede/types";
import { useEffectOnce } from "./useEffectOnce";

export const useTriggerEffect = (effect: () => boolean, dependencies: Any[]) => {
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    const result = effect();
    if (result !== trigger) {
      setTrigger(result);
    }
  }, dependencies);

  return trigger;
};

export const useTriggerEffectOnce = (
  effect: () => boolean,
  triggerCondition: () => boolean,
  dependencies: Any[],
  resetDependencies: Any[],
) => {
  const [trigger, setTrigger] = useState(false);

  useEffectOnce(
    () => {
      const result = effect();
      if (result && !trigger) {
        setTrigger(true);
      }
    },
    triggerCondition,
    dependencies,
    resetDependencies,
  );

  return trigger;
};
